import Excel from "exceljs"

const _defaultHeaderStyle = {
    fill: { type: 'pattern', pattern:'solid', fgColor: { argb:'FF212146'}},
    font: {color: {argb: "FFFFFFFF"}}
};

const saveFile = function(workbook, fileName = 'report'){
    workbook.xlsx.writeBuffer( {
        base64: true
    })
    .then( function (xls64) {
        // build anchor tag and attach file (works in chrome)
        var a = document.createElement("a");
        var data = new Blob([xls64], { type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet" });

        var url = URL.createObjectURL(data);
        a.href = url;
        a.download = `${fileName}.xlsx`;
        document.body.appendChild(a);
        a.click();
        setTimeout(function() {
                document.body.removeChild(a);
                window.URL.revokeObjectURL(url);
            },
            0);
    })
    .catch(function(error) {
        console.log(error.message);
    });
};

const setUpColSizes = function(worksheet){
    for (let i = 0; i < worksheet.columns.length; i += 1) { 
        let dataMax = 0;
        const column = worksheet.columns[i];
        for (let j = 1; j < column.values.length; j += 1) {
          const columnLength = (column.values[j] && column.values[j].length * 1.1) || 0;
          if (columnLength > dataMax) {
            dataMax = columnLength;
          }
        }
        column.width = dataMax < 12 ? 12 : dataMax;
        column.width++;
      }
};

const applyStyleToRowCells = function(row, style) {
    row.eachCell((cell) => {
        style && style.fill && (cell.fill = style.fill);
        style && style.font && (cell.font = style.font);
        style && style.numFmt && (cell.numFmt = style.numFmt);
    })
};

const addRows = function(worksheet, rowsArray){
    rowsArray.forEach(row => {
        const {style, ...data} = row;
        const worksheetRow = worksheet.addRow(data);
        applyStyleToRowCells(worksheetRow, style);
    })
}
const getNewWorkBook = function(jsonData, colDetails, workbookName = 'report', headerDetails, 
{options = {}, conditionalFormatting = []} = {}
){
    let workbook = new Excel.Workbook();
        workbook.views = [
            {
              x: 0, y: 0, width: 10000, height: 20000,
              firstSheet: 0, activeTab: 1, visibility: 'visible'
            }
        ];
    let worksheet = workbook.addWorksheet(workbookName);
    if(!colDetails || (colDetails.length > 0 && typeof colDetails[0] === 'string')){
        let keys = typeof colDetails[0] === 'string' ? colDetails : Object.keys(jsonData[0]);
        colDetails = keys.map(key => {
            return { header: key, key: key };
        });
    }
    if(headerDetails){
        let mainHeaderValues = [];
        colDetails.forEach(e => {
            mainHeaderValues.push(e.header);
            delete e.header;
        });
        let headerDetailsRow = worksheet.addRow(headerDetails.map(h => h.label));
        applyStyleToRowCells(headerDetailsRow, _defaultHeaderStyle)
        worksheet.addRow(headerDetails.map(h => h.value));
        worksheet.addRow([]);
        let mainHeaderRow = worksheet.addRow(mainHeaderValues);
        applyStyleToRowCells(mainHeaderRow, _defaultHeaderStyle)
    }
    worksheet.columns = colDetails;
    Object.assign(worksheet, options)
    conditionalFormatting.forEach(formattingDefinition => {
        worksheet.addConditionalFormatting(formattingDefinition)
    })

    addRows(worksheet, jsonData);
    setUpColSizes(worksheet);
    
    return workbook;
};

const buildWorksheet = function(worksheet, jsonData, colDetails, headerDetails){
    if(!colDetails || (colDetails.length > 0 && typeof colDetails[0] === 'string')){
        let keys = typeof colDetails[0] === 'string' ? colDetails : Object.keys(jsonData[0]);
        colDetails = keys.map(key => {
            return { header: key, key: key };
        });
    }
    if(headerDetails){
        let mainHeaderValues = [];
        colDetails.forEach(e => {
            mainHeaderValues.push(e.header);
            delete e.header;
        });
        let headerDetailsRow = worksheet.addRow(headerDetails.map(h => h.label));
        applyStyleToRowCells(headerDetailsRow, _defaultHeaderStyle)
        worksheet.addRow(headerDetails.map(h => h.value));
        worksheet.addRow([]);
        let mainHeaderRow = worksheet.addRow(mainHeaderValues);
        applyStyleToRowCells(mainHeaderRow, _defaultHeaderStyle)
    }
    worksheet.columns = colDetails;
    worksheet.addRows(jsonData);
    setUpColSizes(worksheet);
};

/**
 * save a xlsx files with the jsonData parameter
 * @param {Array<{
    * tabName: String
    * jsonData: Array<Object>
    * colDetails: Array<{header: String, key: String}>
    * headerDetails: Array<Object>
 * }>} tabsInfo jsonData.<key> must correspond to a key in the headerDatails
 * @param {String} documentName 
 * @example fromJsonMultipleTabs([{
 *  tabName: 'tab1',
 *  jsonData: [{colKey: 'col data'}]
 *  colDetails: [{ header: 'Column Label', key: "colKey" }]
 *  headerDetails: [{label: 'Header col label', value: 'Header col value'}]
 * }], 'filename')
 */
const fromJsonMultipleTabs = function(tabsInfo = [], documentName = ''){
    let workbook = new Excel.Workbook();
    workbook.views = [
        {
          x: 0, y: 0, width: 10000, height: 20000,
          firstSheet: 0, activeTab: 1, visibility: 'visible'
        }
    ];
    tabsInfo.forEach(({jsonData, colDetails, headerDetails, tabName}) => {
        const worksheet = workbook.addWorksheet(tabName);
        buildWorksheet(worksheet, jsonData, colDetails, headerDetails);
    });
    saveFile(workbook, documentName);
};

export default {
    fromJson(jsonArray, colDetails, name = 'report', header = null, options){
        if(jsonArray && jsonArray.length && colDetails){
            let wb = getNewWorkBook(jsonArray, colDetails, name, header, options);
            saveFile(wb, name);
        }
    },
    fromJsonMultipleTabs
} 